module.exports = __webpack_public_path__ + "media/svg/icon_great_fit_purple-3405ed52.svg";